import { type ReactNode, useState } from 'react'

/** Long free-text answers on claim review steps (truncated with show more/less). */
export function ClaimReviewCollapsibleDescription({ text }: { text: string }) {
  const [open, setOpen] = useState(false)
  const long = text.length > 260

  return (
    <div className="flex flex-col gap-[8px]">
      <p
        className={`m-0 whitespace-pre-wrap font-body text-sm font-semibold leading-sm text-text-primary-900 ${
          !open && long ? 'line-clamp-4 max-h-[5.75rem] overflow-hidden' : ''
        }`}
      >
        {text || 'NA'}
      </p>
      {long ? (
        <button
          type="button"
          className="m-0 self-start border-0 bg-transparent p-0 font-body text-sm font-semibold text-background-brand-solid underline decoration-solid underline-offset-2 hover:text-text-brand-secondary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-foreground-brand-solid focus-visible:ring-offset-2"
          onClick={() => setOpen(!open)}
        >
          {open ? 'Show less' : 'Show more'}
        </button>
      ) : null}
    </div>
  )
}

export interface ClaimReviewSummaryRowProps {
  label: string
  children: ReactNode
}

/**
 * Label/value pair on claim confirm screens. Mobile stacks label then value; desktop
 * uses a two-column row with matched type size and baseline alignment.
 */
export function ClaimReviewSummaryRow({ label, children }: ClaimReviewSummaryRowProps) {
  return (
    <div className="flex flex-col gap-[4px] border-b border-border-secondary py-[12px] last:border-b-0 sm:flex-row sm:items-baseline sm:justify-between sm:gap-x-[16px] sm:py-[10px]">
      <span className="shrink-0 font-body text-sm font-regular leading-sm text-text-tertiary-600 sm:basis-[42%] sm:max-w-[42%]">
        {label}
      </span>
      <div className="min-w-0 flex-1 font-body text-sm font-semibold leading-sm text-text-primary-900">
        {children}
      </div>
    </div>
  )
}
